import { Link } from "react-router-dom";

const GuruSupportModal = () => {
  return (
    <div className={`relative flex flex-col justify-start items-center top-[75px] left-[25px] w-[243.5px] h-[335.75px] text-darkslategray`}>
      <div className={`rounded-mini bg-white shadow-[-10.383894920349121px_-8.495914459228516px_28.32px_rgba(0,_0,_0,_0.35),_12.271876335144043px_11.327885627746582px_28.32px_rgba(0,_0,_0,_0.35)] backdrop-blur-lg absolute inset-0 w-[243.5px] h-[335.75px]`} />
      <img
        className="absolute top-[-9px] left-[24px] w-[13px] h-[10px]"
        alt=""
        src="/arrow.svg"
      />
      <div className="z-0 mt-[13px] font-semibold text-yellowgreen w-[135.03px] h-[24.05px]">
        Guru Support
      </div>
      <img
        className="z-0 mt-[5px] w-[245.5px] h-0.25"
        alt=""
        src="/seprator.svg"
      />
      <div className="z-0 my-[15px] text-[10px] mx-3 w-[220px] text-center">
        {`Ready to take your OneScreen experience to the next level? Our Screen Skills Guru team provides expert & friendly, live help and training 24/5 M-F. And the best part? Getting in touch is as easy as touching this green help button and asking us anything.`}
      </div>
      <div
        style={{
          borderRadius: "10px",
          overflow: "hidden",
        }}
        className="z-0 rounded-3xs w-[189px] h-[112.75px] object-cover cursor-pointer"
        alt=""
        src="/video-screen@2x.png"
      >
        <iframe
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/YzVUz00gcLc"
          frameborder="0"
          allow="fullscreen"
        ></iframe>
      </div>
      <img
        className="z-0 mt-[15px] w-[245.5px] h-0.25"
        alt=""
        src="/seprator1.svg"
      />
      <div className="absolute h-[6.85%] w-[64.22%] top-[89.31%] right-[18.04%] bottom-[4.84%] left-[17.74%]">
        <Link to="/screenshare" className="decoration-transparent">
          <div className="absolute h-full w-[47.85%] top-[0%] right-[52.15%] bottom-[0%] left-[0%]">
            <div className="absolute h-full w-full top-[0%] right-[0%] bottom-[0%] left-[0%] rounded-mini bg-lightsteelblue" />
            <div className="absolute text-darkslategray text-[9px] w-full top-[23.33%] left-[0%] inline-block">
              Previous
            </div>
          </div>
        </Link>
        <Link to="/widgets" className="decoration-transparent">
          <div className="absolute h-full w-[47.85%] top-[0%] right-[0%] bottom-[0%] left-[52.15%] text-white">
            <div className="absolute h-full w-full top-[0%] right-[0%] bottom-[0%] left-[0%] rounded-[25px] bg-yellowgreen" />
            <div className="absolute text-[9px] w-full top-[20%] left-[0%] inline-block">
              Continue
            </div>
          </div>
        </Link>
      </div>
      <Link to="/home" className="decoration-transparent">
        <img
          className="absolute h-[13px] w-[13px] top-[3%] right-[3%] bottom-[91.58%] left-[91.38%] max-w-full overflow-hidden max-h-full"
          alt=""
          src="/close.svg"
        />
      </Link>
    </div>
  );
};

export default GuruSupportModal;
